/*eslint-disable */

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import axios from 'axios';
import {
  bus
} from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import debounce from 'lodash/debounce';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import responsiveMixin from '@/mixins/responsive';

const $ = window.jQuery = require('jquery');


// Lazy load components
const selfUserStatus = () => import('@/components/private/workspace/self-user-status');
const chatInfoSection = () => import('@/components/private/workspace/chat-info-section');
const createGroupTeams = () => import('@/components/private/workspace/create-group-teams');
const individualActivityTrackerPopup = () => import('@/components/private/workspace/individual-activity-tracker');
const accessFeaturesForBlurb = () => import('@/components/public/access-features-of-package-popup');


export default {
  name: 'chat-user-list',
  mixins: [responsiveMixin],
  components: {
    selfUserStatus,
    'user-chat-info': chatInfoSection,
    'create-group-teams': createGroupTeams,
    'individual-activity-tracker': individualActivityTrackerPopup,
    'access-feature-of-blurb': accessFeaturesForBlurb
  },
  props: [],
  data() {
    return {
      is_superuser: false,
      selfUserId: '',
      individualActivityTrackerState: false,
      connectionRequestCount: null,
      search_term: '',
      userSearchListTabs: false,
      chatSearchItemListData: null,
      chatSearchItemList: [],
      pinnedChatRoomList: [],
      fullChatRoomListData: null,
      fullChatRoomListResult: [],
      fullChatListForLoadMore: '',
      typingGroupUsersInfoState: '',
      typingUserInfoState: '',
      chatRoomInfo: null,
      collapseActvToggleState: false,
      createGroupPopup: false,
      typingGroupUsersNameState: '',
      searchingContactText: 'Looking for contact',
      chatListAPILoader: false,
      accessFeaturesOfPackageState: false,
      welcomeBlurbState: false,
      menuBurgerState: false,
      isSearchEnabled: false,
      chatRoomClickable: false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getAllLeftChatListDetailsGetters',
    ]),
    selfUserInfo() {
      return this.$store.getters.acUserDetailsStateGetters.data;
    },
    fullChatData() {
      return this.$store.getters.getAllLeftChatListDetailsGetters.data;
    },
  },
  created() {
    this.initializeChatData();
  },
  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID');
    // Typing For Selected Group Event Listener
    bus.$on('TypingEventForSelectedGroupBus', (data) => {
      this.typingGroupUsersInfoState = data;
      if (data.message == 'stop') {
        this.typingGroupUsersInfoState = '';
        this.typingGroupUsersNameState = '';
      }
    });
    // Typing For Selected User Event Listener
    bus.$on('typingEventForChatBus', (data) => {
      this.typingUserInfoState = data;
      if (data.message == 'stop') {
        this.typingUserInfoState = '';
      }
    });

    // User Status Update Event Listener
    bus.$on('userUpdateStatus', (data) => {
      let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID) ||
        this.pinnedChatRoomList.find(item => item.user && item.user.id === data.userID);
      if (targetUserId) {
        targetUserId.user.is_online = data.is_online;
      }
    });

    // User Self Status Event Listener
    bus.$on('userSelfStatus', (data) => {
      let targetUserId = this.fullChatRoomListResult.find(item => item.user && item.user.id === data.userID) ||
        this.pinnedChatRoomList.find(item => item.user && item.user.id === data.userID);
      if (targetUserId) {
        targetUserId.user.current_status = data.current_status;
        targetUserId.user.status_time = data.status_time;
      }
    });

    // Update Message Notification Event Listener
    bus.$on('updateMessageNotification', (data) => {
      let currentSelected = this.chatRoomInfo;
      currentSelected = currentSelected.id;
      if (data.chatRoomId == currentSelected) return;
      this.handleChatRoomNotification(data, currentSelected);
    });
    // Unread Message Count All Cleared For User Event
    bus.$on('unreadCountClearedForUserBus', (data) => {
      if (data == true) {
        let currentSelected = this.chatRoomInfo;
        let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.chat_room === currentSelected.chat_room) ||
          this.pinnedChatRoomList.find(item => item.chat_room === currentSelected.chat_room);
        if (targetUserChatRoom) {
          targetUserChatRoom.unread_count = 0;
        }
      }
    });
    // Create Group Room Event Listener
    bus.$on('createGroupPopupBus', (data) => {
      this.createGroupPopup = data;
    });
    // Self User Chat List Live Update
    bus.$on('selfFullChatListOrdChangedBus', (data) => {
      if (data) {
        this.moveToTopIndexSelectedUserOfLiveChatMethod(data);
      }
    });
    bus.$on('collapseActvToggleStateBus', (data) => {
      this.collapseActvToggleState = data;
    })
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
    bus.$on('individualActivityTrackerStateBus', (data) => {
      this.individualActivityTrackerState = data;
    });
    bus.$on('updateGroupInfoDataBus', (data) => {
      if (data) {
        this.getRoomListMethod();
      }
    })
    $('.chat_menuburger').click(function () {
      $('.chat_menuburger_wrp').toggleClass('active');
    })
    $(document).click(function (event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".chat_menuburger, .chat_menu_list").length) {
        $(".chat_menuburger_wrp").removeClass("active");
      }
    });
    // Mobile View In Chat Disabled Event Listener
    bus.$on('hideChatSectionInMblBus', (data) => {
      if(data){
       this.chatRoomInfo = null;
      }
    });
  },
  methods: {
    mblToolbarEnabledMethod(){
      const frame = document.getElementById('frame');
      if (frame) {
        frame.classList.add('acvt_toolbar');
      }
    },
    getRoomListMethod() {
      this.chatRoomClickable = true;
      this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
        setTimeout(() => {
          this.chatRoomClickable = false;
        }, 500)
      })
    },
    handleChatRoomNotification(data) {
      let targetUserChatRoom = this.fullChatRoomListResult.find(item => item.chat_room === data.chatRoomId) ||
        this.pinnedChatRoomList.find(item => item.chat_room === data.chatRoomId);

      if (targetUserChatRoom) {
        if (this.fullChatRoomListResult.includes(targetUserChatRoom)) {
          this.moveToTopIndexSelectedUserOfLiveChatMethod(data.chatRoomId);
        }
        this.handleNotification(targetUserChatRoom, data);
      }
    },
    handleNotification(room, data) {
      const unreadByRoom = data.unreadByRoom;
      const countForSpecificId = unreadByRoom[room.chat_room];
      if (countForSpecificId > 0) {
        if (Push.Permission.has()) {
          Push.create(data.senderName, {
            body: data.message,
            timeout: 4000,
            onClick: function () {
              window.focus();
              this.close();
            }
          });
          room.unread_count = countForSpecificId;
        } else {
          room.unread_count = countForSpecificId;
          this.playSound(audioPlay); // Assuming playSound is a method of 'this'
        }
      }
    },
    initializeChatData() {
      if (this.fullChatData) {
        this.pinnedChatRoomList = this.fullChatData.pinned_chat || [];
        this.fullChatRoomListResult = this.fullChatData.full_chat.results || [];
        this.fullChatListForLoadMore = this.fullChatData.full_chat.next || '';
        if (this.chatRoomClickable) return;
        this.setInitialChatRoom();
      }
    },
    setInitialChatRoom() {
      if (this.pinnedChatRoomList.length > 0) {
        if (this.isMobile) return;
        this.chatRoomInfo = this.pinnedChatRoomList[0];
        this.welcomeBlurbState = false;
      } else if (this.fullChatRoomListResult.length > 0) {
        if (this.isMobile) return;
        this.chatRoomInfo = this.fullChatRoomListResult[0];
        this.welcomeBlurbState = false;
      } else {
        this.welcomeBlurbState = true;
      }
    },
    // User Searchbar Styling for Code Here
    handleSearchbarFocus() {
      this.isSearchEnabled = true;
    },
    menuBurgerClosedMethod() {
      if (this.menuBurgerState) {
        this.menuBurgerState = false;
      }
    },
    menuBurgerMethod() {
      this.menuBurgerState = true;
    },
    accessFeaturesOfPackagemethod() {
      this.accessFeaturesOfPackageState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    // Chat user List Pagination Of The Event Listener
    handleScroll() {
      const chatListEl = this.$refs.chatList;
      let yScrollHeight = chatListEl.scrollHeight;
      let scrollTopEvt = chatListEl.scrollTop + chatListEl.clientHeight + 1;
      if (scrollTopEvt > yScrollHeight) {
        if (this.fullChatListForLoadMore) {
          if (!this.chatListAPILoader) {
            this.chatListAPILoader = true;
            axios.get(this.fullChatListForLoadMore).then((response) => {
              this.fullChatRoomListResult = [].concat(this.fullChatRoomListResult, response.data.data.full_chat.results);
              this.fullChatListForLoadMore = response.data.data.full_chat.next;
              this.chatListAPILoader = false;
            })
          }
        }
      }
    },
    /*
     * This Will Video Call Request Function
    */
    videoCallRequestFun(callerId, roomId) {
      $('.video_call_request').removeClass('call_actv');
      $('#videocallbtn' + callerId).addClass('call_actv');
      let callerFullName = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name;
      commonSocketConnectMethod.emit({
        callerName: callerFullName,
        type: "videoCalling",
        callerID: this.selfUserId,
        targetId: callerId,
        roomId: roomId
      });
      commonSocketConnectMethod.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      commonSocketConnectMethod.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      commonSocketConnectMethod.$on('videoCallAlertPopupClosed', this.notrecievedCall);
      commonSocketConnectMethod.$on('autoMissedCallEvent', this.autoMissedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserId == getAnswerData.targetId) {
        this.$router.push('/video/call/one-to-one-peer/#' + getAnswerData.roomId);
      }
    },
    getDeclinedOfVideoCall(declinedData) {
      $('#videocallbtn' + declinedData.callerID).removeClass('call_actv');
    },
    notrecievedCall(notrecievedData) {
      $('#videocallbtn' + notrecievedData.targetId).removeClass('call_actv');
    },
    autoMissedCall(mCallData) {
      $('#videocallbtn' + mCallData.targetId).removeClass('call_actv');
    },
    /*
     * this will check the new message notification
     */
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    /*
     * Get Minutes From Status Time Methods
     */
    getStatusTimeOfMinMethod(sc) {
      var cth = moment().format('HH');
      var ctm = moment().format('mm:ss');
      var sth = moment(sc).format('HH');
      var stm = moment(sc).format('mm:ss');
      var cft = cth * parseInt(60) + parseInt(ctm);
      var sft = sth * parseInt(60) + parseInt(stm);
      var nt = cft - sft;
      return nt;
    },
    createGroupPopupEnabledFun() {
      this.createGroupPopup = true;
    },
    individualActivityTrackerOpenMethod() {
      this.individualActivityTrackerState = true;
    },
    /*
     * This Will User Search For New Chat Api
     */
    onChangeSearchUser() {
      if (this.search_term.length >= 3) {
        this.userSearchListTabs = true;
        this.$store.dispatch('getUserForChatAction', {
          search_term: this.search_term
        }).then((response) => {
          this.chatSearchItemListData = response.data;
          this.chatSearchItemList = this.chatSearchItemListData.results;
        })
      } else {
        this.userSearchListTabs = false;
        this.chatSearchItemList = [];
        this.chatSearchItemListData = null;
      }
    },

    debouncedSearch: debounce(function () {
      this.onChangeSearchUser();
    }, 200),

    /*
     * This Will Close User Searchbar
     */
    searchBarForChatClosedFun() {
      this.userSearchListTabs = false;
      this.chatSearchItemList = [];
      this.search_term = '';
      this.chatSearchItemListData = null;
      this.isSearchEnabled = false;
    },
    outsideClickOfSearchFieldMethod() {
      if (this.search_term.length > 0) return;
      this.userSearchListTabs = false;
      this.isSearchEnabled = false;
      this.charSearchOfUsersList = [];
      this.search_term = '';
    },
    selectChatRoomForMessageMethod(roomInfo) {
      if (!roomInfo) return;
      if ((this.chatRoomInfo && this.chatRoomInfo.chat_room) == roomInfo.chat_room) return;
      this.chatRoomInfo = roomInfo;
      if (!this.isMobile) return;
      this.showMenuBarOnMblMethod();
    },
    searchingChatRoomForMessageMethod(roomInfo) {
      if (!roomInfo) return;
      this.chatRoomInfo = roomInfo;
    },

    showMenuBarOnMblMethod() {
      // Get the element with id 'sidepanel'
      const sidepanel = document.getElementById('sidepanel');
      if (sidepanel) {
        sidepanel.classList.add('d-none');
      }

      // Get the element with id 'chatContentWrp'
      const chatContentWrp = document.getElementById('chatContentWrp');
      if (chatContentWrp) {
        chatContentWrp.classList.add('d-block');
      }
    },

    /*
     * This Will Move On Top Selected User From List
     */
    moveToTopIndexSelectedUserOfLiveChatMethod(itemId) {
      const itemIndex = this.fullChatRoomListResult.findIndex(item => item.chat_room === itemId);
      if (itemIndex) {
        this.fullChatRoomListResult.unshift(this.fullChatRoomListResult.splice(itemIndex, 1)[0])
      }
    },
  },
  watch: {
    fullChatData: {
      handler() {
        this.initializeChatData();
      },
      // deep: true,
    },
  }
}